import styled, { css } from "styled-components";
import { GrayColors, TextColorNames } from "@smartsuite/types";

export const Button = styled.div<{
  isActive: boolean;
  borderColor: string;
}>`
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: 350px;
  height: 82px;
  justify-content: center;
  align-items: center;
  background: ${GrayColors["G-0"]};
  border-radius: 8px;
  user-select: none;
  cursor: pointer;

  ${({ isActive, borderColor }) =>
    isActive
      ? css`
          border: 2px solid ${borderColor};
        `
      : css`
          border: 1px dashed ${borderColor};
        `}

  &:hover {
    ${({ isActive, borderColor }) => {
      if (!isActive) {
        return css`
          border: 1px solid ${borderColor};
          background-image: none;
        `;
      }
    }}
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 0.8em;
  color: ${TextColorNames.primary};
`;

export const WarningIcon = styled.div`
  position: absolute;
  right: -25px;
`;
